import { FunctionComponent } from 'react'

import { Path, Svg } from 'react-native-svg'
import { resize } from 'src/utils'

type Props = { size?: number }

export const AlertIcon78: FunctionComponent<Props> = ({ size = 24 }) => {
  const { height, width } = resize({ height: 24, size, width: 24 })

  return (
    <Svg {...{ viewBox: '0 0 24 24', width, height }}>
      <Path
        fill="#404040"
        d="M7.865.303a2.28 2.28 0 0 1 2.271 0l6.722 3.866A2.276 2.276 0 0 1 18 6.14v7.72c0 .815-.436 1.567-1.142 1.974l-6.723 3.864a2.284 2.284 0 0 1-2.271 0l-6.723-3.866A2.275 2.275 0 0 1 0 13.86V6.14c0-.813.435-1.565 1.141-1.971L7.865.303Zm9.124 5.677-3.155 1.74.001 3.82a.5.5 0 0 1-.411.493l-.09.008a.5.5 0 0 1-.5-.5V8.27l-3.307 1.824-.03 8.806.14-.07 6.722-3.864c.396-.229.641-.65.641-1.107V6.14c0-.054-.004-.107-.011-.16ZM1.012 5.968A1.232 1.232 0 0 0 1 6.14v7.72c0 .457.245.879.64 1.107l6.723 3.864c.044.026.089.047.134.067l.03-8.803-7.515-4.127Zm3.716-2.71L1.64 5.036a1.26 1.26 0 0 0-.115.074l7.503 4.12 3.275-1.807-7.575-4.163ZM9.637 1.17a1.277 1.277 0 0 0-1.274 0L5.744 2.674 13.34 6.85l3.143-1.733-.01-.008-.114-.073L9.637 1.17Z"
      />
    </Svg>
  )
}
